const buildProductUrl = ({
  presentationLocale,
  categorySlug,
  subcategorySlug,
  productSlug,
  isServedFromLegacySite,
  legacyURL,
}) => {
  if (isServedFromLegacySite && legacyURL) {
    return legacyURL;
  } else if (presentationLocale) {
    return `/${presentationLocale}/${categorySlug}/${subcategorySlug}/${productSlug}`;
  }

  return `/${categorySlug}/${subcategorySlug}/${productSlug}`;
};

export default buildProductUrl;
